// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.journey_phases__7Z7k- {
  display: grid;
  gap: var(--space-7);
}
.journey_phase__dlUiR {
  display: grid;
  gap: var(--space-5);
  grid-template-columns: minmax(0, 1fr);
}
.journey_phaseNum__Q4\\+-V {
  margin: 0 0 var(--space-2);
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  font-weight: 700;
  color: var(--kur-amber);
}
.journey_phaseTitle__BHg5c {
  margin: 0;
  font-size: clamp(1.6rem, 1.2rem + 1vw, 2.1rem);
  font-weight: 500;
  letter-spacing: var(--tracking-subheading);
  line-height: 1.1;
}
.journey_steps__fwgae {
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
}
.journey_steps__fwgae::before {
  content: "";
  position: absolute;
  left: 1.1rem;
  top: 0.5rem;
  bottom: 0.5rem;
  width: 2px;
  background: var(--color-border);
}
.journey_step__XvYGn {
  position: relative;
  padding: 0 0 var(--space-6) 3.5rem;
}
.journey_step__XvYGn:last-child {
  padding-bottom: 0;
}
.journey_dot__9iQD1 {
  position: absolute;
  left: 0;
  top: -0.1rem;
  width: 2.25rem;
  height: 2.25rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--kur-gold);
  color: #111;
  font-size: var(--text-caption);
  font-weight: 700;
}
.journey_stepTitle__uoTG9 {
  margin: 0 0 var(--space-2);
  font-size: 1.25rem;
  font-weight: 500;
}
.journey_stepText__48Jql {
  margin: 0;
  max-width: 42rem;
  line-height: var(--leading-body);
  color: var(--color-text-muted);
}
@media (min-width: 992px) {
  .journey_phase__dlUiR {
    grid-template-columns: minmax(0, 20rem) minmax(0, 1fr);
    gap: var(--space-8);
    padding-top: var(--space-6);
    border-top: 1px solid var(--color-border);
  }
  .journey_phaseHead__H1bMy {
    position: sticky;
    top: 10rem;
    align-self: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/PHYSICIANS/SECTIONS/JOURNEY/journey.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE;IACE,sDAAsD;IACtD,mBAAmB;IACnB,2BAA2B;IAC3B,yCAAyC;EAC3C;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,iBAAiB;EACnB;AACF","sourcesContent":[".phases {\n  display: grid;\n  gap: var(--space-7);\n}\n.phase {\n  display: grid;\n  gap: var(--space-5);\n  grid-template-columns: minmax(0, 1fr);\n}\n.phaseNum {\n  margin: 0 0 var(--space-2);\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--kur-amber);\n}\n.phaseTitle {\n  margin: 0;\n  font-size: clamp(1.6rem, 1.2rem + 1vw, 2.1rem);\n  font-weight: 500;\n  letter-spacing: var(--tracking-subheading);\n  line-height: 1.1;\n}\n.steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  position: relative;\n}\n.steps::before {\n  content: \"\";\n  position: absolute;\n  left: 1.1rem;\n  top: 0.5rem;\n  bottom: 0.5rem;\n  width: 2px;\n  background: var(--color-border);\n}\n.step {\n  position: relative;\n  padding: 0 0 var(--space-6) 3.5rem;\n}\n.step:last-child {\n  padding-bottom: 0;\n}\n.dot {\n  position: absolute;\n  left: 0;\n  top: -0.1rem;\n  width: 2.25rem;\n  height: 2.25rem;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: var(--kur-gold);\n  color: #111;\n  font-size: var(--text-caption);\n  font-weight: 700;\n}\n.stepTitle {\n  margin: 0 0 var(--space-2);\n  font-size: 1.25rem;\n  font-weight: 500;\n}\n.stepText {\n  margin: 0;\n  max-width: 42rem;\n  line-height: var(--leading-body);\n  color: var(--color-text-muted);\n}\n@media (min-width: 992px) {\n  .phase {\n    grid-template-columns: minmax(0, 20rem) minmax(0, 1fr);\n    gap: var(--space-8);\n    padding-top: var(--space-6);\n    border-top: 1px solid var(--color-border);\n  }\n  .phaseHead {\n    position: sticky;\n    top: 10rem;\n    align-self: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phases": `journey_phases__7Z7k-`,
	"phase": `journey_phase__dlUiR`,
	"phaseNum": `journey_phaseNum__Q4+-V`,
	"phaseTitle": `journey_phaseTitle__BHg5c`,
	"steps": `journey_steps__fwgae`,
	"step": `journey_step__XvYGn`,
	"dot": `journey_dot__9iQD1`,
	"stepTitle": `journey_stepTitle__uoTG9`,
	"stepText": `journey_stepText__48Jql`,
	"phaseHead": `journey_phaseHead__H1bMy`
};
export default ___CSS_LOADER_EXPORT___;
